
export const defaultDataphone = () => {
    return {
        branchoffice_id: null,
        cash_register_id: null,
        provider_id: null,
        code_dataphone: '',
        code_1: '',
    };
};


export default {

    selectedDataphone: defaultDataphone(),
    params: {
        perPage: 50,
        page: 1
    },
    disabledInputs: false,
    actionForm:'create',
    branchOfices:[],
    boxes:[],
    dataphones:[],
    providers:[
        {
            id : 1,
            name :'REDEBAN'
        },
        ],
}



// WEBPACK FOOTER //
// ./src/modules/dataphones/state.js